module.exports = __webpack_public_path__ + "static/sri-lanka-759a06fdc28560c975ce544cfc2ae1b0.svg";